import api from './api';

export const userService = {
    // Tüm kullanıcıları getir
    getAllUsers: async (page = 1, limit = 20, search = '') => {
        const response = await api.get(`/admin/users?page=${page}&limit=${limit}&search=${search}`);
        return response.data;
    },

    // Kullanıcı detayını getir
    getUserDetail: async (userId) => {
        const response = await api.get(`/admin/users/${userId}`);
        return response.data;
    },

    // Kullanıcı planını güncelle
    updateUserPlan: async (userId, plan) => {
        const response = await api.patch(`/admin/users/${userId}/plan`, { plan });
        return response.data;
    },

    // Kullanıcı durumunu değiştir (aktif/pasif)
    toggleUserStatus: async (userId, isActive) => {
        const response = await api.patch(`/admin/users/${userId}/status`, { is_active: isActive });
        return response.data;
    },

    // Admin yetkisi ver/al
    setUserAdmin: async (userId, isAdmin) => {
        const response = await api.patch(`/admin/users/${userId}/admin`, { is_admin: isAdmin });
        return response.data;
    }
};